import { makeStyles } from "@material-ui/core/styles";

export const cancelRemittanceStyles = makeStyles(
  theme => ({
    btnCloseIcon: {
      marginLeft: "300px"
    },
    btnRemit: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main
    },
    buttonActionCenter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginTop: 20
    },
    centerContent: {
      fontWeight: 500,
      padding: 10,
      textAlign: "center"
    },
    displayFlexMarginRight20: {
      marginRight: "20px"
    },
    divFlexCentered: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20
    },
    divFlexCentered100: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center"
    },
    midContent: {
      fontWeight: 700,
      textAlign: "center"
    },
    templateDialogTitle: {
      fontSize: 20,
      fontWeight: 700,
      marginLeft: 2
    },
    textWhite: {
      color: "#FFF"
    }
  }),
  { name: "CancelRemittanceStyles" }
);
